module.exports = __webpack_public_path__ + "static/media/img6.ed1db211.jpg";